import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient) { }
  

  saveEmployee(id: any, data: any) {

   const { company, ...payload } = data

    if (id) {
      return this.http.put(urls.API_URL + urls.EMPLOYEE + `/${company}/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.EMPLOYEE +'/'+ company, payload)
      .pipe(catchError(errorHandl));

  }

  getEmployee(queryParams: any = {}) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.EMPLOYEE, { params })
      .pipe(catchError(errorHandl));
  }

 getEmployeeById(id: any) {
      return this.http.get(urls.API_URL + urls.EMPLOYEE + `/${id}`)
        .pipe(catchError(errorHandl));
  }

  syncEmployee(compamyId:any, employeeId:any, queryParams: any = {}) {
      const params = new HttpParams({ fromObject: queryParams || {} });
      return this.http.get(urls.API_URL + urls.EMPLOYEE + `/${compamyId}/${urls.SYNC}/${employeeId}`, { params })
        .pipe(catchError(errorHandl));
  }
}
